import React from "react";
import pentagonPhoto from "../PentagonPhoto.png";

function Header() {
  return (
    <header className="masthead">
      <div className="masthead-content">
        <div className="visually-hidden">
          <h1>Pentagon Properties rental properties in Halifax and Wolfville, Nova Scotia</h1>
          <p>
            Browse available apartments, unit photos, and contact Pentagon Properties about
            housing in Nova Scotia.
          </p>
        </div>
        <img
          className="masthead-image"
          src={pentagonPhoto}
          alt="Pentagon Properties rental housing in Halifax and Wolfville, Nova Scotia"
        />
      </div>
    </header>
  );
}

export default Header;
